import { puzzlesBanner } from 'common/modules/experiments/tests/puzzles-banner';
import { remoteRRHeaderLinksTest } from 'common/modules/experiments/tests/remote-header-test';
import { signInGateMainControl } from 'common/modules/experiments/tests/sign-in-gate-main-control';
import { signInGateMainVariant } from 'common/modules/experiments/tests/sign-in-gate-main-variant';
import { signInGateUsMandatory } from 'common/modules/experiments/tests/sign-in-gate-us-mandatory';
export const concurrentTests = [
    signInGateMainVariant,
    signInGateMainControl,
    signInGateUsMandatory,
    puzzlesBanner,
    remoteRRHeaderLinksTest,
];
